import { theme } from '@bit/jimmijoensson.keyhole.components.keyhole-theme'
import * as React from 'react'
import { LayoutChangeEvent, LayoutRectangle, ScaledSize, StyleSheet, View, ViewProps, ViewStyle } from 'react-native'


export interface OverlayBoxLayoutProps extends ViewProps {
  centered?: boolean
  children: React.ReactNode
  dims: ScaledSize
  onOverlayLayout?: ViewProps['onLayout']
  overlayContent: React.ReactNode
  overlayStyle?: ViewProps['style']
}

const OverlayBoxLayout = ({
  centered,
  children,
  dims,
  onLayout,
  onOverlayLayout,
  overlayContent,
  overlayStyle,
  style,
  ...props
}: OverlayBoxLayoutProps) => {
  const [wrapperDims, setWrapperDims] = React.useState<LayoutRectangle | undefined>()

  const handleOnLayout = React.useCallback((e: LayoutChangeEvent) => {
    setWrapperDims(e.nativeEvent.layout)
    if (onLayout) onLayout(e)
  }, [])

	return (
		<View
      onLayout={handleOnLayout}
      style={[
        dims.width > theme.breakpoints.md ? styles.wrapper : styles.wrapperSm,
        {
          justifyContent: centered ? 'center' : undefined,
        },
        style,
      ]} 
      {...props}
    >
      {children}
      <View
        onLayout={onOverlayLayout}
        style={[
          dims.width > theme.breakpoints.md ? styles.overlay : styles.overlaySm,
          (wrapperDims && dims.width < theme.breakpoints.md) 
            ? {
              width: wrapperDims.width - 16,
            }
            : undefined,
          centered ? { top: undefined } : undefined,
          overlayStyle
        ]}
      >
        {overlayContent}
      </View>
		</View>
	)
}

export interface OverlayBoxLayoutStyles {
  overlay: ViewStyle
  overlaySm: ViewStyle
  wrapper: ViewStyle
  wrapperSm: ViewStyle
}

const styles = StyleSheet.create<OverlayBoxLayoutStyles>({
  overlay: {
    minWidth: 300,
    position: 'absolute',
    right: 0,
    top: 56,

  },
  overlaySm: {
    position: 'relative',
    bottom: 16,
  },
  wrapper: {
    position: 'relative',
    paddingRight: 72,
  },
  wrapperSm: {
    alignItems: 'center',
    position: 'relative',
  },
})

export default OverlayBoxLayout